import { ZeroQueryType } from '@atlassian/search-client';

const ZeroQueryTypesV0 = [
	ZeroQueryType.RECENT_WORK,
	ZeroQueryType.RELATED_QUESTION,
	ZeroQueryType.WHO_IS,
];

const ZeroQueryTypesV1 = [
	ZeroQueryType.COLLABORATOR_PROFILE,
	ZeroQueryType.CONFLUENCE_PAGES_CREATED,
	ZeroQueryType.CONFLUENCE_PAGES_CREATED_30_DAYS,
	ZeroQueryType.CONFLUENCE_PAGES_CREATED_7_DAYS,
	ZeroQueryType.CONFLUENCE_PAGES_CREATED_COLLABORATOR,
	ZeroQueryType.CONFLUENCE_PAGES_CREATED_COLLABORATOR_30_DAYS,
	ZeroQueryType.CONFLUENCE_PAGES_CREATED_COLLABORATOR_7_DAYS,
	ZeroQueryType.JIRA_NLQ,
	ZeroQueryType.JIRA_NLQ_COLLABORATOR,
	ZeroQueryType.JIRA_TICKETS_ASSIGNED,
	ZeroQueryType.JIRA_TICKETS_CREATED,
	ZeroQueryType.JIRA_TICKETS_CREATED_COLLABORATOR,
	ZeroQueryType.THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
	ZeroQueryType.THIRD_PARTY_GOOGLE_MY_DOCS,
	ZeroQueryType.THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
	ZeroQueryType.THIRD_PARTY_SHAREPOINT_MY_DOCS,
	ZeroQueryType.THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
	ZeroQueryType.THIRD_PARTY_SLACK_MY_MESSAGES,
];

const ZeroQueryTypes3P = [
	ZeroQueryType.THIRD_PARTY_GOOGLE_COLLABORATOR_DOCS,
	ZeroQueryType.THIRD_PARTY_GOOGLE_MY_DOCS,
	ZeroQueryType.THIRD_PARTY_SHAREPOINT_COLLABORATOR_DOCS,
	ZeroQueryType.THIRD_PARTY_SHAREPOINT_MY_DOCS,
	ZeroQueryType.THIRD_PARTY_SLACK_COLLABORATOR_MESSAGES,
	ZeroQueryType.THIRD_PARTY_SLACK_MY_MESSAGES,
];

export const getZeroQueryVersion = (zeroQueryType: ZeroQueryType) => {
	if (ZeroQueryTypesV0.includes(zeroQueryType)) {
		return 0;
	} else if (ZeroQueryTypesV1.includes(zeroQueryType)) {
		return 1;
	}
	return null;
};

export const is3PZeroQuery = (zeroQueryType: ZeroQueryType) =>
	ZeroQueryTypes3P.includes(zeroQueryType);
